// extracted by mini-css-extract-plugin
module.exports = {"form":"SalesSiteForm_form__GLFP9"};